export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6571.1c706785.jpg";